__turbopack_context__.v({
  "visually-hidden": "VisuallyHidden-module-scss-module__5BhjbG__visually-hidden",
});
